import {AppState} from '../reducerType';
import {ModalPopupSize} from '../../../popups/Modal/ModalTypes';

export const selectModalPopupSize = (state: AppState): ModalPopupSize => state.popups.modalPopupSize;
export const selectNeedToShow = (state: AppState): boolean => state.popups.needToShow;